import React, { useState } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import { useForm } from 'react-hook-form';
import PortalButton from '../../components/Button';
import Datepicker from '../../components/Datepicker';
import w9form from '../../images/w9form.png';
function W9form() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const onSubmit = (data) => console.log(data);

  const [ProfileData, setProfileData] = useState({
    First_Name: '',
    Last_Name: '',
    Email: '',
    Country: '',
    Address: '',
    Address2: '',
    City: '',
    State: '',
    Zip_Code: '',
    Business_Name: '',
    Federal_Tax: ['Individual/sole proprietor', 'C Corporation', 'S Corporation', 'Partnership', 'LLC', 'Trust/estate', 'Custom'],
    Exempt_Code: '',
    FATCA_Code: '',
    SSN: '',
    Certification: [
      'The number shown on this form is my correct taxpayer identification number (or I am waiting for a number to be issued to me); and',
      'I am not subject to backup withholding because: (a) I am exempt from backup withholding, or (b) I have not been notified by the Internal Revenue Service (IRS) that I am subject to backup withholding as a result of a failure to report all interest or dividends, or (c) the IRS has notified me that I am no longer subject to backup withholding; and',
      'I am a U.S. citizen or other U.S. person (defined below); and',
      'The FATCA code(s) entered on this form (if any) indicating that I am exempt from FATCA reporting is correct.',
    ],
  });

  return (
    <>
      <div className="space-y-2">
        <div className="relative flex">
          <div className="w-full h-full flex flex-col after:flex-1">
            <div className="w-full mx-auto">
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="space-y-8">
                  <div>
                    <p className="text-center text-base mb-10 py-5 border-b border-t bg-indigo-50 border-indigo-50">
                      <span className=" font-semibold">W-9 </span>
                      <span> Request for Taxpayer Identification Number and Certification</span>
                    </p>
                    <div className="grid gap-5 md:grid-cols-4 text-sm md:text-base">
                      <div className="col-span-4 ">
                        <p className=" font-semibold">
                          Full Legal Name (as shown on your income tax return)<span className="text-red-500">*</span>
                        </p>
                      </div>
                      <div className="col-span-4 md:col-span-2 ">
                        {/* <label className="block text-sm font-medium mb-1 text-gray-900" htmlFor="default">
                          First Name
                        </label> */}
                        <input
                          type="text"
                          placeholder="First Name"
                          defaultValue={ProfileData.First_Name}
                          className="w-full form-input bg-portal-100 border-0 font-medium text-portal-900"
                          {...register('First Name', {
                            required: true,
                            maxLength: 80,
                          })}
                        />
                      </div>
                      <div className="col-span-4 md:col-span-2 ">
                        {/* <label className="block text-sm font-medium mb-1 text-gray-900" htmlFor="default">
                          Last Name
                        </label> */}
                        <input
                          type="text"
                          placeholder="Last Name"
                          defaultValue={ProfileData.Last_Name}
                          className="w-full form-input bg-portal-100 border-0 font-medium text-portal-900"
                          {...register('Last Name', {
                            required: true,
                            maxLength: 80,
                          })}
                        />
                      </div>
                      <div className="col-span-4 mt-6 ">
                        <p className=" font-semibold">
                          Address<span className="text-red-500">*</span>
                        </p>
                      </div>
                      <div className="col-span-4 md:col-span-2">
                        {/* <label className="block text-sm font-medium mb-1 text-gray-900" htmlFor="default">
                          Street Address
                        </label> */}
                        <input
                          type="text"
                          placeholder="Street Address"
                          defaultValue={ProfileData.Address}
                          className="w-full form-input bg-portal-100 border-0 font-medium text-portal-900"
                          {...register('Street Address', {
                            required: true,
                            pattern: /^\S+@\S+$/i,
                          })}
                        />
                      </div>
                      <div className="col-span-4 md:col-span-2">
                        {/* <label className="block text-sm font-medium mb-1 text-gray-900" htmlFor="default">
                          Street Address Line 2
                        </label> */}
                        <input
                          type="text"
                          placeholder="Street Address Line 2"
                          defaultValue={ProfileData.Address2}
                          className="w-full form-input bg-portal-100 border-0 font-medium text-portal-900"
                          {...register('Street Address Line 2', {
                            required: true,
                            pattern: /^\S+@\S+$/i,
                          })}
                        />
                      </div>
                      <div className="col-span-4 md:col-span-2 ">
                        {/* <label className="block text-sm font-medium mb-1 text-gray-900" htmlFor="default">
                          City
                        </label> */}
                        <input
                          type="text"
                          placeholder="City"
                          defaultValue={ProfileData.City}
                          className="w-full form-input bg-portal-100 border-0 font-medium text-portal-900"
                          {...register('City', {
                            required: true,
                            maxLength: 80,
                          })}
                        />
                      </div>
                      <div className="col-span-4 md:col-span-2 ">
                        {/* <label className="block text-sm font-medium mb-1 text-gray-900" htmlFor="default">
                          State / Province
                        </label> */}
                        <input
                          type="text"
                          placeholder="State / Province"
                          defaultValue={ProfileData.State}
                          className="w-full form-input bg-portal-100 border-0 font-medium text-portal-900"
                          {...register('State', {
                            required: true,
                            maxLength: 80,
                          })}
                        />
                      </div>
                      <div className="col-span-4 md:col-span-2 ">
                        {/* <label className="block text-sm font-medium mb-1 text-gray-900" htmlFor="default">
                          Postal / Zip Code
                        </label> */}
                        <input
                          type="number"
                          placeholder="Postal / Zip Code"
                          defaultValue={ProfileData.Zip_Code}
                          className="w-full form-input bg-portal-100 border-0 font-medium text-portal-900"
                          {...register('Zip Code', {
                            required: true,
                            minLength: 6,
                            maxLength: 12,
                          })}
                        />
                      </div>
                      <div className="col-span-4 md:col-span-2 ">
                        {/* <label className="block text-sm font-medium mb-1 text-gray-900" htmlFor="default">
                          Country
                        </label> */}
                        <input
                          type="text"
                          placeholder="Country"
                          defaultValue={ProfileData.Country}
                          className="w-full form-input bg-portal-100 border-0 font-medium text-portal-900"
                          {...register('Country', {
                            required: true,
                            minLength: 6,
                            maxLength: 12,
                          })}
                        />
                      </div>

                      <div className="col-span-4 mt-6 ">
                        <label className="font-semibold" htmlFor="default">
                          Business name/disregarded entity name, if different from above.
                        </label>
                        <input
                          type="tel"
                          defaultValue={ProfileData.Business_Name}
                          className="w-full form-input bg-portal-100 border-0 font-medium text-portal-900 mt-2"
                          {...register('Referral Code', {
                            required: true,
                            minLength: 6,
                            maxLength: 12,
                          })}
                        />
                      </div>
                      <div className="col-span-4 mt-6">
                        <label className="font-semibold" htmlFor="default">
                          Check appropriate box for federal tax classification:<span className="text-red-500">*</span>
                        </label>
                        {ProfileData.Federal_Tax.map((item, index) => (
                          <div className="my-1 text-sm">
                            <label key={index} className="flex items-center">
                              <input
                                // ref={register({ required: 'This is required' })}
                                name="federaltax"
                                value={true}
                                type="checkbox"
                                className="form-checkbox border-2 border-blue-400"
                              />
                              <span className=" ml-2"> {item}</span>
                            </label>
                          </div>
                        ))}
                      </div>
                      <div className="col-span-4 mt-2">
                        <p className="text-center  font-semibold py-5 border-b border-t bg-indigo-50 border-indigo-50">
                          Exemptions (see instructions):
                        </p>
                      </div>
                      <div className="col-span-4 mt-6 ">
                        <label className="font-semibold" htmlFor="default">
                          Exempt payee code (if any)
                        </label>
                        <input
                          type="tel"
                          defaultValue={ProfileData.Exempt_Code}
                          className="w-full form-input bg-portal-100 border-0 font-medium text-portal-900 mt-2"
                          {...register('Referral Code', {
                            required: true,
                            minLength: 6,
                            maxLength: 12,
                          })}
                        />
                      </div>
                      <div className="col-span-4 mt-6 ">
                        <label className="font-semibold" htmlFor="default">
                          Exemption from FATCA reporting code (if any)
                        </label>
                        <input
                          type="tel"
                          defaultValue={ProfileData.FATCA_Code}
                          className="w-full form-input bg-portal-100 border-0 font-medium text-portal-900 mt-2"
                          {...register('Referral Code', {
                            required: true,
                            minLength: 6,
                            maxLength: 12,
                          })}
                        />
                      </div>
                      {/* <div className="col-span-4 mt-2">
                        <p className="text-center  font-semibold py-5 border-b border-t bg-indigo-50 border-indigo-50">
                          Part 1: Taxpayer Identification Number (TIN)
                        </p>
                      </div> */}
                      <div className="col-span-4 mt-6 ">
                        <label className="font-semibold" htmlFor="default">
                          Social Security Number<span className="text-red-500">*</span>
                        </label>
                        <input
                          type="tel"
                          defaultValue={ProfileData.FATCA_Code}
                          className="w-full form-input bg-portal-100 border-0 font-medium text-portal-900 mt-2"
                          {...register('Referral Code', {
                            required: true,
                            minLength: 6,
                            maxLength: 12,
                          })}
                        />
                      </div>
                      {/* <div className="col-span-4 mt-2">
                        <p className="text-center  font-semibold py-5 border-b border-t bg-indigo-50 border-indigo-50">
                          Part 2: Certification
                        </p>
                      </div> */}
                      <div className="col-span-4 mt-6">
                        <label className="font-semibold" htmlFor="default">
                          Under penalties of perjury, I certify that (please affirm each of the following statements):
                          <span className="text-red-500">*</span>
                        </label>
                        {ProfileData.Certification.map((item, index) => (
                          <div className="my-1">
                            <label key={index} className="flex text-sm">
                              <input
                                // ref={register({ required: 'This is required' })}
                                name="federaltax"
                                value={true}
                                type="checkbox"
                                className="form-checkbox border-2 border-blue-400 mt-0.5"
                              />
                              <span className=" ml-2"> {item}</span>
                            </label>
                          </div>
                        ))}
                      </div>
                      <div className="col-span-4 mt-2">
                        <p className="text-center  font-semibold py-5 border-b border-t bg-indigo-50 border-indigo-50">
                          Signature Verification
                        </p>
                      </div>
                      <div className="col-span-4 mt-6 text-sm">
                        <p>
                          By signing in the box below, I agree that my electronic signature is the legally binding equivalent to
                          my handwritten signature. I acknowledge that my electronic signature has the same validity and meaning
                          as my handwritten signature. I will not, at any time in the future, repudiate the meaning of my
                          electronic signature or claim that my electronic signature is not legally binding.
                        </p>
                        <p className="font-medium italic mt-4 text-sm">
                          The Internal Revenue Service does not require your consent to any provision of this document other than
                          the certifications required to avoid backup withholding.
                        </p>
                      </div>
                      <div className="col-span-4 mt-6 text-sm overflow-hidden">
                        <SignatureCanvas
                          penColor="green"
                          canvasProps={{ width: 500, height: 200, className: 'border shadow-md' }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default W9form;
